<template>
  <div>
    <div class="border border-[#e5e7eb] rounded-[8px] overflow-hidden bg-white">
      <b-overlay
        :show="loadingData"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        class="w-full"
        rounded="sm"
      >
        <div class="table-responsive m-0">
          <table class="custom-ro-service-table w-full mb-0">
            <thead>
              <tr>
                <th class="th-expedition">
                  Nama Ekspedisi
                </th>
                <th class="text-center min-w-[140px]">
                  Reguler
                </th>
                <th class="text-center min-w-[140px]">
                  Cargo
                </th>
                <th class="text-center min-w-[140px]">
                  Lite
                </th>
                <th class="text-center min-w-[140px]">
                  Flat
                </th>
                <th class="text-center min-w-[140px]">
                  Instant
                </th>
              </tr>
            </thead>
            <tbody v-if="listServices.length > 0">
              <tr
                v-for="(item, idx) in listServices"
                :key="`service-item-${idx}`"
                class="service-item-row"
              >
                <!-- Expedition Name & Logo -->
                <td>
                  <div class="flex items-center gap-[10px]">
                    <div class="inline-flex items-center justify-center w-[48px] h-[28px] bg-[#ffece9] rounded-full px-[8px] py-[3px]">
                      <img
                        :src="item.image_logo"
                        :alt="item.shipping_name"
                        class="max-h-[18px] max-w-[36px] object-contain"
                      >
                    </div>
                    <span class="text-[13.5px] font-semibold text-[#1f2937]">
                      {{ item.shipping_name }}
                    </span>
                  </div>
                </td>

                <!-- Reguler Column -->
                <td class="text-center">
                  <div class="flex justify-center items-center">
                    <button
                      type="button"
                      class="inline-flex items-center justify-center w-[20px] h-[20px] rounded-[5px] p-0 border-[1.5px] transition-all duration-150 focus:outline-none"
                      :class="[
                        item.is_regular === 0
                          ? 'bg-[#f9fafb] border-[#e5e7eb] cursor-not-allowed opacity-60'
                          : item.regular_status === 1
                            ? 'bg-[#f95031] border-[#f95031] cursor-pointer'
                            : 'bg-white border-[#d1d5db] hover:border-[#f95031] cursor-pointer'
                      ]"
                      :disabled="item.is_regular === 0"
                      @click="toggleCheckbox(item, 'regular')"
                    >
                      <svg
                        v-if="item.regular_status === 1"
                        width="12"
                        height="10"
                        viewBox="0 0 12 10"
                        fill="none"
                      >
                        <path
                          d="M1 5L4.5 8.5L11 1.5"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </td>

                <!-- Cargo Column -->
                <td class="text-center">
                  <div class="flex justify-center items-center">
                    <button
                      type="button"
                      class="inline-flex items-center justify-center w-[20px] h-[20px] rounded-[5px] p-0 border-[1.5px] transition-all duration-150 focus:outline-none"
                      :class="[
                        item.is_cargo === 0
                          ? 'bg-[#f9fafb] border-[#e5e7eb] cursor-not-allowed opacity-60'
                          : item.cargo_status === 1
                            ? 'bg-[#f95031] border-[#f95031] cursor-pointer'
                            : 'bg-white border-[#d1d5db] hover:border-[#f95031] cursor-pointer'
                      ]"
                      :disabled="item.is_cargo === 0"
                      @click="toggleCheckbox(item, 'cargo')"
                    >
                      <svg
                        v-if="item.cargo_status === 1"
                        width="12"
                        height="10"
                        viewBox="0 0 12 10"
                        fill="none"
                      >
                        <path
                          d="M1 5L4.5 8.5L11 1.5"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </td>

                <!-- Lite Column -->
                <td class="text-center">
                  <div class="flex justify-center items-center">
                    <button
                      type="button"
                      class="inline-flex items-center justify-center w-[20px] h-[20px] rounded-[5px] p-0 border-[1.5px] transition-all duration-150 focus:outline-none"
                      :class="[
                        item.is_lite === 0
                          ? 'bg-[#f9fafb] border-[#e5e7eb] cursor-not-allowed opacity-60'
                          : item.lite_status === 1
                            ? 'bg-[#f95031] border-[#f95031] cursor-pointer'
                            : 'bg-white border-[#d1d5db] hover:border-[#f95031] cursor-pointer'
                      ]"
                      :disabled="item.is_lite === 0"
                      @click="toggleCheckbox(item, 'lite')"
                    >
                      <svg
                        v-if="item.lite_status === 1"
                        width="12"
                        height="10"
                        viewBox="0 0 12 10"
                        fill="none"
                      >
                        <path
                          d="M1 5L4.5 8.5L11 1.5"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </td>

                <!-- Flat Column -->
                <td class="text-center">
                  <div class="flex justify-center items-center">
                    <button
                      type="button"
                      class="inline-flex items-center justify-center w-[20px] h-[20px] rounded-[5px] p-0 border-[1.5px] transition-all duration-150 focus:outline-none"
                      :class="[
                        item.is_flat === 0
                          ? 'bg-[#f9fafb] border-[#e5e7eb] cursor-not-allowed opacity-60'
                          : item.flat_status === 1
                            ? 'bg-[#f95031] border-[#f95031] cursor-pointer'
                            : 'bg-white border-[#d1d5db] hover:border-[#f95031] cursor-pointer'
                      ]"
                      :disabled="item.is_flat === 0"
                      @click="toggleCheckbox(item, 'flat')"
                    >
                      <svg
                        v-if="item.flat_status === 1"
                        width="12"
                        height="10"
                        viewBox="0 0 12 10"
                        fill="none"
                      >
                        <path
                          d="M1 5L4.5 8.5L11 1.5"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </td>

                <!-- Instant Column -->
                <td class="text-center">
                  <div class="flex justify-center items-center">
                    <button
                      type="button"
                      class="inline-flex items-center justify-center w-[20px] h-[20px] rounded-[5px] p-0 border-[1.5px] transition-all duration-150 focus:outline-none"
                      :class="[
                        item.is_instant === 0
                          ? 'bg-[#f9fafb] border-[#e5e7eb] cursor-not-allowed opacity-60'
                          : item.instant_status === 1
                            ? 'bg-[#f95031] border-[#f95031] cursor-pointer'
                            : 'bg-white border-[#d1d5db] hover:border-[#f95031] cursor-pointer'
                      ]"
                      :disabled="item.is_instant === 0"
                      @click="toggleCheckbox(item, 'instant')"
                    >
                      <svg
                        v-if="item.instant_status === 1"
                        width="12"
                        height="10"
                        viewBox="0 0 12 10"
                        fill="none"
                      >
                        <path
                          d="M1 5L4.5 8.5L11 1.5"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="!loadingData">
              <tr>
                <td
                  colspan="6"
                  class="text-center py-[16px] text-[#6b7280]"
                >
                  Tidak Ada Data Untuk Ditampilkan
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
    </div>

    <!-- Bottom Action Buttons -->
    <div class="flex justify-end items-center gap-[12px] mt-[16px]">
      <button
        type="button"
        class="px-[24px] py-[8px] text-[13px] font-medium rounded-[8px] border border-[#e5e7eb] bg-white text-[#374151] cursor-pointer transition-all duration-200 hover:bg-[#f9fafb] hover:border-[#d1d5db] disabled:opacity-50 disabled:cursor-not-allowed disabled:text-[#9ca3af] focus:outline-none"
        :disabled="!isChanged || loadingData"
        @click="resetChanges"
      >
        Reset
      </button>
      <button
        type="button"
        class="px-[24px] py-[8px] text-[13px] font-medium rounded-[8px] border-0 bg-[#f95031] text-white cursor-pointer transition-all duration-200 hover:bg-[#e03e21] disabled:opacity-50 disabled:bg-[#d1d5db] disabled:cursor-not-allowed focus:outline-none"
        :disabled="!isChanged || loadingData"
        @click="handleSave"
      >
        Simpan
      </button>
    </div>

    <ModalPIN
      v-if="source !== 'rajaongkir'"
      id="modal-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Konfirmasi Perubahan?"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Batal"
      @on-confirm-button="saveChanges"
    />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'

export default {
  name: 'ROTableExpeditionsService',
  components: { ModalPIN },
  props: {
    source: {
      type: String,
      default: 'komship',
    },
  },
  data() {
    return {
      loadingData: false,
      listServices: [],
      defaultListServices: [],
    }
  },
  computed: {
    isChanged() {
      if (!this.defaultListServices || !this.listServices) return false
      if (this.defaultListServices.length !== this.listServices.length) return true

      const checkFields = ['regular_status', 'cargo_status', 'lite_status', 'flat_status', 'instant_status']
      return this.listServices.some((item, i) => {
        const orig = this.defaultListServices[i]
        if (!orig) return true
        return checkFields.some(field => Number(item[field] || 0) !== Number(orig[field] || 0))
      })
    },
  },
  watch: {
    source() {
      this.getListServices()
    },
  },
  mounted() {
    this.getListServices()
  },
  methods: {
    toggleCheckbox(item, type) {
      if (item[`is_${type}`] === 0) return
      const field = `${type}_status`
      const nextVal = item[field] === 1 ? 0 : 1
      this.$set(item, field, nextVal)
    },
    resetChanges() {
      this.listServices = cloneDeep(this.defaultListServices)
    },
    getListServices() {
      this.loadingData = true
      const params = {
        source: this.source,
      }
      const url = '/komship/api/v1/admin/shipment/configure/service'

      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.listServices = cloneDeep(data || [])
          this.defaultListServices = cloneDeep(data || [])
          this.loadingData = false
        })
        .catch(() => {
          this.loadingData = false
          this.$toast_error({ message: 'Tidak mendapatkan list ekspedisi' })
        })
    },
    handleSave() {
      if (this.source === 'rajaongkir') {
        this.saveChanges()
      } else {
        this.$bvModal.show('modal-pin')
      }
    },
    updateExpeditionService() {
      const params = {
        source: this.source,
        services: this.listServices.map(item => ({
          shipment_id: item.shipment_id || item.id || 0,
          regular_status: Number(item.regular_status || 0),
          cargo_status: Number(item.cargo_status || 0),
          lite_status: Number(item.lite_status || 0),
          flat_status: Number(item.flat_status || 0),
          instant_status: Number(item.instant_status || 0),
        })),
      }
      const url = '/komship/api/v1/admin/shipment/configure/service'
      return this.$http_new.put(url, params)
    },
    async saveChanges() {
      if (this.source !== 'rajaongkir') {
        this.$bvModal.hide('modal-pin')
      }
      this.loadingData = true

      this.updateExpeditionService()
        .then(() => {
          this.$toast_success({ message: 'Perubahan servis ekspedisi berhasil disimpan' })
          this.getListServices()
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal melakukan update servis ekspedisi' })
          this.loadingData = false
        })
    },
    verifiedPin() {
      this.saveChanges()
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-ro-service-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 0;

  thead th {
    background-color: #f8f9fa !important;
    color: #1f2937 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    border: none !important;
    border-bottom: 1px solid #e5e7eb !important;
    padding: 12px 16px !important;
    vertical-align: middle !important;
    text-transform: none !important;
  }

  .th-expedition {
    width: 320px;
    min-width: 260px;
    text-align: left;
  }

  .service-item-row {
    transition: background-color 0.15s ease;

    &:hover td {
      background-color: #fafbfc;
    }

    td {
      background-color: #ffffff;
      padding: 12px 16px !important;
      vertical-align: middle !important;
      border: none !important;
      border-bottom: 1px solid #f3f4f6 !important;
      font-size: 13px !important;
      color: #1f2937;
    }

    &:last-child td {
      border-bottom: none !important;
    }
  }

  @media (max-width: 768px) {
    .th-expedition {
      width: 240px;
      min-width: 200px;
    }
  }
}
</style>
